import {
  ref,
  toRef,
} from "vue";

import {
  find,
} from "lodash-es";

export default function ViewAPI(props, { emit }, {
  deleteDataLocal = () => {},
  modelView = ref(undefined),
  reloadData = () => {},
  viewCurrent = ref(undefined),
}) {
  const views = toRef(props, "views");

  const initViewCurrent = () => {
    if (views.value?.length) {
      const VIEW_ACTIVE = find(views.value, ["active", true]);
      if (VIEW_ACTIVE) {
        viewCurrent.value = VIEW_ACTIVE;
      } else {
        viewCurrent.value = views.value[0];
      }
      modelView.value = viewCurrent.value.id;
    }
  };

  const updateView = (arg = {}) => {
    modelView.value = arg._modelView;
    viewCurrent.value = arg.view;
    emit("updateView", arg);
    if (!arg.init && viewCurrent.value.update) {
      deleteDataLocal();
      reloadData();
    }
  };

  return {
    initViewCurrent,
    updateView,
  };
}
